<template>
    <div class="container pt-8 pb-4">
        <div class="flex justify-content-end mb-4">
            <Button label="Adcionar Plano de Aula" @click="editarPlanos" />
        </div>


        <div v-for="plano in planos" :key="plano.id" class="bg-white shadow-1 border-round-sm p-4 mb-4">
            <div class="flex justify-content-between align-items-center">
                <div class="text-xl font-medium text-color "> {{ plano.titulo }}</div>
                <div class="d-flex gap-3">
                    <Button icon="pi pi-comment" v-tooltip.top="'Enviar feedback no Teams'" text rounded severity="secondary" @click="enviarMensagemTeams(plano.id)" />
                    <Button v-tooltip.top="'Deixar visível para o estudante'"
                        v-if="plano.visivelParaOEstudante == false" icon="pi pi-eye-slash" severity="secondary" text
                        rounded aria-label="Tornar visível plano"
                        @click="tornarVisivelPlano(plano.idPlanoAula, true)" />
                    <Button v-tooltip.top="'Ocultar para os estudantes'" v-else icon="pi pi-eye" severity="secondary"
                        text rounded aria-label="Tornar visível plano"
                        @click="tornarVisivelPlano(plano.idPlanoAula, false)" />
                    <Button v-tooltip.top="'Editar plano'" icon="pi pi-pencil" severity="secondary" text rounded
                        aria-label="Editar plano" @click="editarPlano(plano.id)" />
                    <Button
                        v-tooltip.top="'Excluir plano de todas as turmas e todos os grupos vinculados a ele. \n Essa ação é irreversível.'"
                        icon="pi pi-trash" severity="secondary" text rounded aria-label="Excluir plano"
                        @click="excluirPlano(plano.id)" />
                </div>

            </div>
        </div>
    </div>



    <Dialog v-model:visible="visible" modal header="Adicionar Plano" class="h-full w-full "></Dialog>
</template>
<script setup>


import { computed, ref, onMounted } from 'vue'
import { supabase } from '@/supabase'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

const store = useStore()
import {useRouter} from 'vue-router'
const router = useRouter()

import Button from 'primevue/button'
import Dialog from 'primevue/dialog'


import { deletarPlano } from '@/api/fetchPlanos';


const visible = ref(false)
const loading = ref(false)
const turma = computed(() => store.state.turma)
const planos = ref([])

const editarPlanos = ()=>{
    router.push({path:'/professor/turma/planos/editar'})
}


onMounted(() => {
    listarPlanos()
})
const listarPlanos = async ()=> {
    store.dispatch('updateLoading', true)
    const {data, erro} = await supabase
    .from('planos')
    .select('id, titulo, linkComOrientacoes, trimestre, planos_aulas!inner (id, aula, plano, visivelParaOEstudante)')
    .eq('planos_aulas.aula', turma.value.idDaAula)
    .not('planos_aulas', 'is', null)
        .order('id', { ascending: false })
    console.log(data)
    let array = []
    data.forEach(item => {
        array.push({ id: item.id, titulo: item.titulo, linkComOrientacoes: item.linkComOrientacoes, trimestre: item.trimestre, visivelParaOEstudante: item.planos_aulas[0].visivelParaOEstudante, idPlanoAula: item.planos_aulas[0].id })
    })
    planos.value = array
    store.dispatch('updateLoading',false)
}

function enviarMensagemTeams(idPlano){
    console.log(turma.value)
    router.push({ path: '/professor/mensagem-teams/', query: { idDoPlano: idPlano, idDaAula: turma.value.idDaAula, idDaTurma: turma.value.idDaTurma}})
}

const tornarVisivelPlano = async (id, valor)=> {
    const {data, error} = await supabase
    .from('planos_aulas')
    .update({ visivelParaOEstudante: valor })
    .eq('id', id)
    listarPlanos()
}

const editarPlano =  (id) => {
    router.push({path:'/professor/turma/planos/editar', query: {id}})
}

const excluirPlano = async (id) => {
    loading.value = true
    const resultado = await deletarPlano(id);
    if(resultado == true){
        planos.value = planos.value.filter(item => item.id != id)
    }

    loading.value = false

    
}


</script>
<style >
.p-dialog {
    max-height: 100%;
}

.p-dialog-content {
    height: 100%;
}

.p-dialog .p-dialog-header {
    border-radius: 0px;
}

.p-dialog-content {
    border-radius: 0px;
}
</style>